<div class="mkg-frontpanel">
  <h2 mat-dialog-title>{{ isEditing ? 'Editar' : 'Novo' }} Tipo de Agendamento</h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="mat-typography">
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="description" placeholder="Ex: Aniversário">
          @if (isSystemClass) {
            <mat-icon matSuffix
                      matTooltip="Tipo usado pela sincronização automática da Agenda">
              lock
            </mat-icon>
          }
          @if (isSystemClass) {
            <mat-hint>Tipo do sistema: a descrição não pode ser alterada</mat-hint>
          }
          <mat-error *ngIf="form.get('description')?.hasError('required')">
            Descrição é obrigatória
          </mat-error>
          <mat-error *ngIf="form.get('description')?.hasError('maxlength')">
            Descrição deve ter no máximo 100 caracteres
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cor</mat-label>
          <mat-select formControlName="color">
            <mat-select-trigger>
              <div class="color-select-trigger">
                <div class="color-preview-dot" [style.background-color]="form.get('color')?.value"></div>
                <span>{{ getColorName(form.get('color')?.value) }}</span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let color of availableColors" [value]="color.primary">
              <div class="color-option">
                <div class="color-preview-dot" [style.background-color]="color.primary"></div>
                <span>{{ color.name }}</span>
              </div>
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('color')?.hasError('required')">
            Cor é obrigatória
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Usuários Permitidos</mat-label>
          <mat-select formControlName="users" multiple>
            <mat-option *ngFor="let user of allUsers" [value]="user.id">
              {{ user.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Selecione os usuários que podem visualizar este tipo de agendamento. Caso nenhum seja selecionado, todos poderão ver.</mat-hint>
        </mat-form-field>
      </div>


      <div class="event-preview-container" *ngIf="form.get('color')?.value">
        <div class="event-preview"
             [style.background-color]="getSelectedColorSet()?.secondary"
             [style.border-left-color]="getSelectedColorSet()?.darker">
          <span [style.color]="form.get('color')?.value">
            {{ form.get('description')?.value || 'Exemplo de Evento' }}
          </span>
        </div>
      </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" [disabled]="isSubmitting" (click)="onCancel()">Cancelar</button>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="form.invalid || isSubmitting">
        <mat-spinner *ngIf="isSubmitting" diameter="20" class="spinner-button"></mat-spinner>
        <span *ngIf="!isSubmitting">{{ isEditing ? 'Atualizar' : 'Salvar' }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
